import get from 'lodash/get';
import { behaviors as GuideItemBehaviors } from '../guideItemTypes';

export default function shouldNavigate(guideItem, selectedContentId) {
  const shouldNavigateToProfile =
    get(guideItem, 'behaviors.default.actionName') ===
      GuideItemBehaviors.profile &&
    get(guideItem.actions, 'profile.destinationInfo.id') !== selectedContentId;

  const shouldNavigateToBrowse =
    get(guideItem, 'behaviors.default.actionName') ===
      GuideItemBehaviors.browse &&
    get(guideItem.actions, 'browse.destinationInfo.id') !== selectedContentId;

  return shouldNavigateToBrowse || shouldNavigateToProfile;
}
